function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7301 5.32091L39.4272 10.1471L36.73 14.9732L33.9606 19.7501L28.5 19.7941L23.0394 19.7501L20.27 14.9732L17.5728 10.1471L20.27 5.32083L23.0394 0.54404L28.5 0.500016L33.9606 0.54404L36.7301 5.32091Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7301 45.3209L39.4272 50.1471L36.73 54.9732L33.9606 59.7501L28.5 59.7941L23.0394 59.7501L20.27 54.9732L17.5728 50.1471L20.27 45.3208L23.0394 40.544L28.5 40.5L33.9606 40.544L36.7301 45.3209Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.7301 35.3209L56.4272 40.1471L53.73 44.9732L50.9606 49.7501L45.5 49.7941L40.0394 49.7501L37.27 44.9732L34.5728 40.1471L37.27 35.3208L40.0394 30.544L45.5 30.5L50.9606 30.544L53.7301 35.3209Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7301 35.3209L22.4272 40.1471L19.73 44.9732L16.9606 49.7501L11.5 49.7941L6.03942 49.7501L3.26995 44.9732L0.572786 40.1471L3.27 35.3208L6.03942 30.544L11.5 30.5L16.9606 30.544L19.7301 35.3209Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M53.7301 15.3209L56.4272 20.1471L53.73 24.9732L50.9606 29.7501L45.5 29.7941L40.0394 29.7501L37.27 24.9732L34.5728 20.1471L37.27 15.3208L40.0394 10.544L45.5 10.5L50.9606 10.544L53.7301 15.3209Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7301 15.3209L22.4272 20.1471L19.73 24.9732L16.9606 29.7501L11.5 29.7941L6.03942 29.7501L3.26995 24.9732L0.572786 20.1471L3.27 15.3208L6.03942 10.544L11.5 10.5L16.9606 10.544L19.7301 15.3209Z"
});

function SvgRing1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "white",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing1);
export default __webpack_public_path__ + "static/media/Ring1.0e428787.svg";
export { ForwardRef as ReactComponent };